import { Component, OnInit, Input, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';
import { ExpenseFilter } from '../../../models/expenses/expenseFilter';

@Component({
  selector: 'expense-filter',
  templateUrl: './expense-filter.component.html',
  styleUrls: ['./expense-filter.component.css']
})
export class ExpenseFilterComponent implements OnInit {
	showFilter: boolean = false;
	
	@Input() filter: ExpenseFilter = new ExpenseFilter();
	@Output() search: EventEmitter<ExpenseFilter> = new EventEmitter<ExpenseFilter>()
	
	@HostListener('document:click', ['$event'])
	clickout(event) {
		if (!this._elementRef.nativeElement.contains(event.target))
			this.showFilter = false;
	}

	constructor(private _elementRef: ElementRef,) { }

	ngOnInit() {
	}

	toggleFilter() {
		this.showFilter = !this.showFilter;
	}

	onSearchClick() {
		this.search.emit(this.filter);
		this.showFilter = false;
	}

	onClearClick() {
		this.filter.expenseDateFrom = null;
		this.filter.expenseDateTo = null;
		this.filter.expenseType = null;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/expenses/expense-filter/expense-filter.component.ts